/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs */

const en_ticket_action_leave_parts_at_pudo_success = /** @type {(inputs: Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parts left at PUDO.`)
};

const ja_ticket_action_leave_parts_at_pudo_success = /** @type {(inputs: Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品をPUDOに預けました。`)
};

const fr_ticket_action_leave_parts_at_pudo_success = /** @type {(inputs: Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièces déposées au PUDO.`)
};

const de_ticket_action_leave_parts_at_pudo_success = /** @type {(inputs: Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile am PUDO hinterlegt.`)
};

/**
* | output |
* | --- |
* | "Parts left at PUDO." |
*
* @param {Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_leave_parts_at_pudo_success = /** @type {((inputs?: Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Leave_Parts_At_Pudo_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_leave_parts_at_pudo_success(inputs)
	if (locale === "ja") return ja_ticket_action_leave_parts_at_pudo_success(inputs)
	if (locale === "fr") return fr_ticket_action_leave_parts_at_pudo_success(inputs)
	return de_ticket_action_leave_parts_at_pudo_success(inputs)
});